import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  AfterViewInit,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { OptimizationRecommendationSlug, ViguideRecommendationsStore } from '@store';
import { matTooltipSetter } from '../../functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-optimization-recommendation',
  templateUrl: './optimization-recommendation.component.html',
  styleUrls: ['./optimization-recommendation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptimizationRecommendationComponent implements AfterViewInit {
  @HostListener('window:resize')
  onResize(): void {
    this.setTextExceedingWrapper();
  }

  @ViewChild('actualText') actualText: ElementRef;

  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() title: string;
  @Input() description: string;
  @Input() recommendationName: OptimizationRecommendationSlug;

  isTextExceedingWrapper: boolean;
  private readonly textWrapperHeight = 72;

  constructor(
    private cdRef: ChangeDetectorRef,
    private viguideRecommendationsStore: ViguideRecommendationsStore
  ) {}

  ngAfterViewInit(): void {
    this.setTextExceedingWrapper();
    this.cdRef.detectChanges();
  }

  closeRecommendationTile(): void {
    this.viguideRecommendationsStore.closeRecommendationTile(this.recommendationName);
  }

  private setTextExceedingWrapper(): void {
    const output = this.actualText.nativeElement.offsetHeight > this.textWrapperHeight;
    if (output !== this.isTextExceedingWrapper) {
      this.isTextExceedingWrapper = output;
      this.cdRef.markForCheck();
    }
  }
}
